export default function WarningBanner() {
  return (
    <section className="py-6 md:py-8 bg-accent-50 border-y border-accent-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-error-warning-line text-accent-600 text-lg" />
            </div>
            <div>
              <h3 className="text-sm font-bold text-foreground-950">정보 이용 시 주의사항</h3>
              <p className="text-xs text-foreground-600 mt-1 leading-relaxed">
                스카연에서 제공하는 정보는 참고용이며, 모든 책임은 이용자에게 있습니다. 검증된
                사이트라도 이용 시 주의가 필요하며, 제보 내용은 정확한 정보를 바탕으로
                작성되었습니다.
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-2">
            <button className="px-4 py-2 bg-white border border-background-300 rounded text-xs font-medium text-foreground-700 hover:border-primary-300 transition-colors whitespace-nowrap">
              정보 기준 페이지이동
            </button>
            <button className="px-4 py-2 bg-white border border-background-300 rounded text-xs font-medium text-foreground-700 hover:border-primary-300 transition-colors whitespace-nowrap">
              정보및이력신청안내
            </button>
            <button className="px-4 py-2 bg-white border border-background-300 rounded text-xs font-medium text-foreground-700 hover:border-primary-300 transition-colors whitespace-nowrap">
              운영정책 보기
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}